import styled from 'styled-components';

export const SectionRoot = styled.section`
  max-width: 144rem;
  margin: 0 auto;
`;

export const SectionContainer = styled.div<{
  orientation?: 'left' | 'right';
}>`
  display: flex;
  gap: 4rem;
  flex-direction: ${({ orientation }) =>
    orientation === 'right' ? 'row' : 'row-reverse'};
  justify-content: space-between;
  align-items: center;
  padding: 2.5rem 0 7.5rem 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column-reverse;
    padding: 3rem 2rem;
  }
`;

export const ContentContainer = styled.div<{ maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  margin: 0 auto;
`;

export const HighlightText = styled.h3`
  color: #009fe3;
  font-family: proxima-nova, sans-serif;
  font-size: 20px;
  font-weight: 800;
  line-height: 140%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 18px;
  }
`;

export const Title = styled.h1`
  font-family: proxima-nova, sans-serif;
  font-size: 40px;
  font-weight: 900;
  line-height: 115%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 32px;
  }
`;

export const Paragraph = styled.p`
  font-family: proxima-nova, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  color: #172839;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 16px;
    line-height: 140%;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 36.4rem;
  max-width: 54.9rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    order: 1;
    height: 100%;
  }
`;

export const EventImage = styled.img<{
  orientation?: 'left' | 'right';
}>`
  border-radius: 4rem;

  width: 100%;
  height: 100%;
  object-fit: contain;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    border-radius: 2rem;
  }
`;

export const EventVideo = styled.video<{
  orientation?: 'left' | 'right';
  maxHeight?: string;
}>`
  border-top-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-bottom-right-radius: ${({ orientation }) =>
    orientation === 'right' ? '0' : '4rem'};
  border-top-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};
  border-bottom-left-radius: ${({ orientation }) =>
    orientation === 'left' ? '0' : '4rem'};

  width: 100%;
  height: 100%;
  object-fit: contain;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    border-radius: 2rem;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1.875rem;
`;
